import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BaseModule } from '@sb/library/base';
import { ButtonModule } from '@sb/library/button';
import { PopoverComponent } from './popover.component';

@NgModule({
    declarations: [
        PopoverComponent
    ],
    imports: [
    CommonModule,
    ButtonModule,
    BaseModule
],
    exports: [
        PopoverComponent,
    ]
})
export class PopoverModule { }
